export default {
  getLoading: (state) => state.isLoading,

  getProjectFolders: (state) => {
    const projectFolders = [...state.projectFolders];
    return projectFolders;
  },
};
